import React, { Component } from "react";
import { Container, Row, Col } from 'reactstrap';
import { Navigate } from "react-router-dom";


import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import TuneIcon from '@mui/icons-material/Tune';

import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import AttachEmailIcon from '@mui/icons-material/AttachEmail';
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';

import FormControl from '@mui/material/FormControl';
import Button from '@mui/material/Button';
import { format } from 'date-fns'
 

import { Snackbar } from '@mui/material';
import Moment from 'moment';

import AuthService from "../services/LoginService";
import EventBus from "../common/EventBus";

import { AddDossier } from "./AddDossier";
import DossierService from "../services/DossierService";

//import { AddFilter } from "./AddFilter";

import { DataGrid, gridClasses } from '@mui/x-data-grid';
import { alpha, styled } from '@mui/material/styles';

//import VisibilityIcon from '@mui/icons-material/Visibility';
//import OverlayTrigger from 'react-bootstrap/OverlayTrigger';

//const success = red[500]; // #f44336
//const warning = purple['A200']; // #e040fb
//const accent = purple.A200; // #e040fb (alternative method)

const ODD_OPACITY = 0.2;
const StripedDataGrid = styled(DataGrid)(({ theme }) => ({
    [`& .${gridClasses.row}.odd`]: {
        fontSize: 12,
    },
    
    [`& .${gridClasses.row}.even`]: {
        fontSize: 12,
        backgroundColor: theme.palette.grey[200],
        '&:hover, &.Mui-hovered': {
            backgroundColor: alpha(theme.palette.primary.main, ODD_OPACITY),
            '@media (hover: none)': {
                backgroundColor: 'transparent',
            },
        },
        '&.Mui-selected': {
            backgroundColor: alpha(
                theme.palette.primary.main,
                ODD_OPACITY + theme.palette.action.selectedOpacity,
            ),
            '&:hover, &.Mui-hovered': {
                backgroundColor: alpha(
                    theme.palette.primary.main,
                    ODD_OPACITY +
                    theme.palette.action.selectedOpacity +
                    theme.palette.action.hoverOpacity,
                ),
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: alpha(
                        theme.palette.primary.main,
                        ODD_OPACITY + theme.palette.action.selectedOpacity,
                    ),
                },
            },
        },
    },
}));


class DossierList extends Component {

    emptyDossier = {
        sessionId: 0,
        sessionName: "",
        formationName: "",
        status: "",
        entreprise: "",
        createdAt: "",
        studentName: "",
        payMode: "",
        studentId: 0,
        payModeList: [],
        student: {
            id: 1,
            firstName: "",
            lastName: "",
            email: "",
            phone: "",
            address: "",
            zipCode: "",
            city: "",
            country: ""
        }
    };



    constructor(props) {
        super(props);
        var tempDate = new Date();
        tempDate.setMonth(tempDate.getMonth() - 12)
        
       
        //console.log(format(tempDate, 'yyyy-MM-dd'));
        this.state = {
            dossiers: [],
            redirect: null,
            addDossierShow: false,
            addFilterShow: false,
            currentDossier: this.emptyDossier,
            snackbaropen: false,
            statusDossier: null,

            page: 0,
            count: 0,
            pageSize: 100,
            sessionNameFilter: '',
            minSessDtFilter: Moment('2020-01-01').format('yyyy-MM-DD'),
            maxSessDtFilter: Moment('2050-01-01').format('yyyy-MM-DD'),
            minCreaDtFilter: format(tempDate, 'yyyy-MM-dd'),
            maxCreaDtFilter: Moment('2050-01-01').format('yyyy-MM-DD'),
            statusFilter: null,
            payModeFilter: null,

        };
        this.pageSizes = [5, 25, 50, 100];


        // this.remove = this.remove.bind(this);
        this.retrieveDossiers = this.retrieveDossiers.bind(this);
        // this.handlePageChange = this.handlePageChange.bind(this);
        this.remove = this.remove.bind(this);
        this.editDossier = this.editDossier.bind(this);
        this.handleStatusChange = this.handleStatusChange.bind(this);
        this.handlePageChange = this.handlePageChange.bind(this);
        this.handlePageSizeChange = this.handlePageSizeChange.bind(this);
        this.applyFilter = this.applyFilter.bind(this);
        this.refreshDossier = this.refreshDossier.bind(this);
        
    }

    componentDidMount() {
        const currentUser = AuthService.getCurrentUser();
        if (!currentUser) {
            this.setState({ redirect: "/login" });
        } else {
            this.retrieveDossiers();
        }
    }

    refreshDossier(newDossier) {
        //console.log('update newDossier : ');
        //console.log(newDossier);
        // console.log('In ... applyFilter : ');
        //console.log(this.state);
        let newDossiers = this.state.dossiers.map((row) =>
            row.id === newDossier.id ? newDossier : row,
        );

        this.setState({
            dossiers: newDossiers,
        });
    }

    /* componentDidUpdate(previousProps, CurrentState) {
         console.log('componentDidUpdate');
         console.log(this.props.currentdossier);
 
         if (previousProps.currentstudent !== this.props.currentstudent) {
             console.log('mise a jour');
             this.retrieveDossiers();
         }
     }*/
    /*
        componentDidUpdate(previousProps, previousState) {
            //console.log(this.props.currentstudent);
            if (previousProps.currentstudent !== this.props.currentstudent) {
    
                this.retrieveDossiers();
            }
        }
    */
    retrieveDossiers() {
        //const { firstNameFilter, lastNameFilter, page, pageSize } = this.state;
        //console.log('In ... retrieveDossiers : ');
        //console.log(this.state);
        const { sessionNameFilter, minSessDtFilter, maxSessDtFilter, minCreaDtFilter, maxCreaDtFilter, statusFilter, payModeFilter, page, pageSize } = this.state;
        //console.log('sessionNameFilter : '+ sessionNameFilter);
        const params = this.getRequestParams(sessionNameFilter, minSessDtFilter, maxSessDtFilter, minCreaDtFilter, maxCreaDtFilter, statusFilter, payModeFilter, page, pageSize);
        DossierService.getAll(params)
            .then((response) => {
                const { dossiers, totalItems } = response.data;

                this.setState({
                    dossiers: dossiers,
                    count: totalItems,
                });
                 console.log(response.data);
            })
            .catch((error) => {
                console.log(error);
                if (error.response && error.response.status === 401) {
                    EventBus.dispatch("logout");
                }
            });

    }

    getRequestParams(sessionNameFilter, minSessDtFilter, maxSessDtFilter, minCreaDtFilter, maxCreaDtFilter, statusFilter, payModeFilter, page, pageSize) {
        let params = {};

        if (sessionNameFilter) {
            params["sessionName"] = sessionNameFilter;
        }
        if (minSessDtFilter) {
            params["minSessionDate"] = minSessDtFilter;
        }
        if (maxSessDtFilter) {
            params["maxSessionDate"] = maxSessDtFilter;
        }
        if (minCreaDtFilter) {
            params["minCreationDate"] = minCreaDtFilter;
        }
        if (maxCreaDtFilter) {
            params["maxCreationDate"] = maxCreaDtFilter;
        }
        if (statusFilter) {
            params["status"] = statusFilter;
        }
        if (payModeFilter) {
            params["payMode"] = payModeFilter;
        }
        if (page) {
            params["page"] = page ;
        }

        if (pageSize) {
            params["size"] = pageSize;
        }

        return params;
    }

    handlePageSizeChange(event) {
        this.setState(
            {
                pageSize: event.target.value,
                page: 1
            },
            () => {
                this.retrieveDossiers();
            }
        );
    }



    handlePageChange(value) {
        console.log('handlePageChange ')
        //console.log(event)
        console.log(value)
        this.setState(
            {
                page: value.page,
                pageSize: value.pageSize,
            },
            () => {
                this.retrieveDossiers();
            }
        );
    }


    updateStatus(id, status) {
        const params = this.getUpdateReqParams(status);
        DossierService.updateStatus(id, params)
            .then((response) => {
                const { message } = response.data;
                //alert(message)
                this.setState({ snackbaropen: true, snackbarmsg: message });
            })
            .catch((err) => {
                console.log(err);
                const {  message } = err.response.data;
                this.setState({ snackbaropen: true, snackbarmsg: message });
            });

    }

    getUpdateReqParams(status) {
        let params = {};

        if (status) {
            params["status"] = status;
        }
        return params;
    }

    editDossier(dossier) {
        // studentId.preventDefault();
        //console.log('STUDENT List contactID = ' + contract.id);
        this.setState({ currentDossier: dossier });
        this.setState({ addDossierShow: true });
    }

    filterDossier() {
        this.setState({ addFilterShow: true });
    }

    remove(id) {
        DossierService.delete(id)
            .then((response) => {
                const {  message } = response.data;
                this.setState({ snackbaropen: true, snackbarmsg: message });
                this.retrieveDossiers();
            })
            .catch((err) => {
                console.log(err);
                const {  message } = err.response.data;
                this.setState({ snackbaropen: true, snackbarmsg: message });
            });
    }

    async editPdf(id, num) {
        DossierService.buildPdfContract(id)
            .then(response => {
                return response.data;
            }).then((blob) => {
                const href = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = href;
                link.setAttribute('download', `contract-${num}.pdf`); //or any other extension
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }).catch((err) => {
                return Promise.reject({ Error: 'Something Went Wrong', err });
            });
    }

    async sendPdf(id, num) {
        DossierService.sendPdfContract(id)
            .then(response => {
                console.log(response.data);
                const {  message } = response.data;
                this.setState({ snackbaropen: true, snackbarmsg: message });
                return response.data;
            }).catch((err) => {
                const {  message } = err.response.data;
                this.setState({ snackbaropen: true, snackbarmsg: message });
                return Promise.reject({ Error: 'Something Went Wrong', err });
            });
    }

    async editLivret(id, num) {
        DossierService.buildPdfLivret(id)
            .then(response => {
                return response.data;
            }).then((blob) => {
                const href = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = href;
                link.setAttribute('download', `LIVRET_DACCUEIL_SIMPHONIECILS.pdf`); //or any other extension
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }).catch((err) => {
                return Promise.reject({ Error: 'Something Went Wrong', err });
            });
    }

    async sendLivret(id, num) {
        DossierService.sendPdfLivret(id)
            .then(response => {
                console.log(response.data);
                const {  message } = response.data;
                this.setState({ snackbaropen: true, snackbarmsg: message });
                return response.data;
            }).catch((err) => {
                const {  message } = err.response.data;
                this.setState({ snackbaropen: true, snackbarmsg: message });
                return Promise.reject({ Error: 'Something Went Wrong', err });
            });
    }

    async editConvocation(id) {
        DossierService.buildPdfConvocation(id)
            .then(response => {
                return response.data;
            }).then((blob) => {
                const href = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = href;
                link.setAttribute('download', `Convocation_${id}.pdf`); //or any other extension
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }).catch((err) => {
                return Promise.reject({ Error: 'Something Went Wrong', err });
            });
    }

    async sendConvocation(id) {
        DossierService.sendPdfConvocation(id)
            .then(response => {
                console.log(response.data);
                const { message } = response.data;
                this.setState({ snackbaropen: true, snackbarmsg: message });
                return response.data;
            }).catch((err) => {
                const {  message } = err.response.data;
                this.setState({ snackbaropen: true, snackbarmsg: message });
                return Promise.reject({ Error: 'Something Went Wrong', err });
            });
    }

    async editEmargement(id) {
        DossierService.buildPdfEmargement(id)
            .then(response => {
                return response.data;
            }).then((blob) => {
                const href = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = href;
                link.setAttribute('download', `Emargement_${id}.pdf`); //or any other extension
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }).catch((err) => {
                return Promise.reject({ Error: 'Something Went Wrong', err });
            });
    }

    async sendEmargement(id) {
        DossierService.sendPdfEmargement(id)
            .then(response => {
                console.log(response.data);
                const {  message } = response.data;
                this.setState({ snackbaropen: true, snackbarmsg: message });
                return response.data;
            }).catch((err) => {
                const {  message } = err.response.data;
                this.setState({ snackbaropen: true, snackbarmsg: message });
                return Promise.reject({ Error: 'Something Went Wrong', err });
            });
    }

    async editAttestation(id) {
        DossierService.buildPdfAttestation(id)
            .then(response => {
                return response.data;
            }).then((blob) => {
                const href = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = href;
                link.setAttribute('download', `Attestation_${id}.pdf`); //or any other extension
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }).catch((err) => {
                return Promise.reject({ Error: 'Something Went Wrong', err });
            });
    }

    async sendAttestation(id) {
        DossierService.sendPdfAttestation(id)
            .then(response => {
                console.log(response.data);
                const {  message } = response.data;
                this.setState({ snackbaropen: true, snackbarmsg: message });
                return response.data;
            }).catch((err) => {
                const {  message } = err.response.data;
                this.setState({ snackbaropen: true, snackbarmsg: message });
                return Promise.reject({ Error: 'Something Went Wrong', err });
            });
    }


    snackbarClose = (event) => {
        this.setState({ snackbaropen: false });
    }

    handleStatusChange(event, id) {

        const status = event.target.value;
        //console.log('Change status dossier : ' + id)
        //console.log('Index : ' + index)
   

        const {
            dossiers
        } = this.state;

      //  let dossier = dossiers[index];

        let indexOfTodo = dossiers.findIndex(dossier => dossier.id === id);
        let dossier = dossiers[indexOfTodo];
        //console.log('dossier index : ');
        //console.log(dossier);

        dossier.status = status;

        const newDossiers = dossiers.map(obj => {
            // 👇️ if id equals 2, update country property
            if (obj.id === id) {
                return { ...obj, status: status };
            }

            // 👇️ otherwise return the object as is
            return obj;
        });

        //setData(newState);
        this.setState({ newDossiers });

        this.updateStatus(id, status)
        //this.setState({ dossiers });


    }


    applyFilter(newSessionNameFilter) {
        console.log('update filter from modal : '+ newSessionNameFilter);
       // console.log('In ... applyFilter : ');
        //console.log(this.state);
        this.setState({ sessionNameFilter: newSessionNameFilter }, () => {
            //console.log(this.state.sessionNameFilter, 'sessionNameFilter');
            this.retrieveDossiers();
          });
        
        
    }
    render() {

        if (this.state.redirect) {
            return <Navigate to={this.state.redirect} />
        }

        const {
            dossiers,
            page,
            count,
            pageSize,
            isLoading,
        } = this.state;


        const columns = [
            { field: 'id', headerName: 'ID', maxwidth: 80 },
            {
                field: 'sessionName',
                headerName: 'Session',
                minwidth: 100,
                flex: 0.3,
                //editable: true,
            },
            {
                field: 'statut',
                headerName: 'Etat',
                sortable: false,
                filterable: false,
                minwidth: 120,
                flex: 0.3,
                renderCell: (params) => (
                    <div>
                        <tr valign="middle" >
                <td>
                    <FormControl sx={{ m: 1,  width: '110px' }} size="small">
                        <Select

                            labelId="statusDossier"
                            id="statusDossier"
                            value={params.row.status}
                            onChange={(e) => this.handleStatusChange(e, params.row.id)}
                        >
                            <MenuItem value={'En Attente'}>En Attente</MenuItem>
                            <MenuItem value={'En Cours'}>En Cours</MenuItem>
                            <MenuItem value={'Validé'}>Validé</MenuItem>
                            <MenuItem value={'Terminé'}>Terminé</MenuItem>
                            <MenuItem value={'Facturé'}>Facturé</MenuItem>
                        </Select>
                    </FormControl>
                    </td>
                    </tr>
                    </div>
                ),
            },
            {
                field: 'createdAt',
                headerName: 'Date',
                minwidth: 10,
                flex: 0.2,
                //editable: true,
            },
            {
                field: 'student',
                headerName: 'Stagiaire',
                minwidth: 50,
                flex: 0.3,
                valueGetter: (param) => {
                    //console.log(param);
                    return `${param.row.student.lastName}  ${param.row.student.firstName}`;
                }
            },
            {
                field: 'payMode',
                headerName: 'Financement',
                minwidth: 30,
                flex: 0.2,

            },
            {
                field: 'price',
                headerName: 'Prix',
                minwidth: 20,
                flex: 0.1,
            },
            
            {
                field: 'acceuil',
                headerName: 'Acceuil',
                sortable: false,
                filterable: false,
                minwidth: 30,
                flex: 0.2,
                renderCell: (params) => (
                    <div>

                    <IconButton aria-label="pdf" color={params.row.livretSent ? 'success' : 'warning'} onClick={() => this.editLivret(params.row.id, params.row.student.lastName)} >
                        <PictureAsPdfIcon />
                    </IconButton>

                    <IconButton aria-label="emailpdf" color={params.row.livretSent ? 'success' : 'warning'} onClick={() => this.sendLivret(params.row.id, params.row.student.lastName)} >
                        <AttachEmailIcon />
                    </IconButton>
                    </div>
                ),
            },
            {
                field: 'contrat',
                headerName: 'Contrat',
                sortable: false,
                filterable: false,
                minwidth: 100,
                flex: 0.2,
                renderCell: (params) => (
                    <div>

                    <IconButton aria-label="pdf" color={params.row.contratSent ? 'success' : 'warning'} onClick={() => this.editPdf(params.row.id, params.row.student.lastName)} disabled={!params.row.contractEligible}>
                        <PictureAsPdfIcon />
                    </IconButton>

                    <IconButton aria-label="emailpdf" color={params.row.contratSent ? 'success' : 'warning'} onClick={() => this.sendPdf(params.row.id, params.row.student.lastName)} disabled={!params.row.contractEligible}>
                        <AttachEmailIcon />
                    </IconButton>
                    </div>
                ),
            },
            {
                field: 'convocation',
                headerName: 'Convocation',
                sortable: false,
                filterable: false,
                minwidth: 100,
                flex: 0.2,
                renderCell: (params) => (
                    <div>

                    <IconButton aria-label="pdf" color={params.row.convocationSent ? 'success' : 'warning'} onClick={() => this.editConvocation(params.row.id)}  >
                        <PictureAsPdfIcon />
                    </IconButton>

                    <IconButton aria-label="emailpdf" color={params.row.convocationSent ? 'success' : 'warning'} onClick={() => this.sendConvocation(params.row.id)}   >
                        <AttachEmailIcon />
                    </IconButton>
                    </div>
                ),
            },
            {
                field: 'emargement',
                headerName: 'Emargement',
                sortable: false,
                filterable: false,
                minwidth: 100,
                flex: 0.2,
                renderCell: (params) => (
                    <div>

                    <IconButton aria-label="pdf" color={params.row.emargementSent ? 'success' : 'warning'} onClick={() => this.editEmargement(params.row.id)}  >
                        <PictureAsPdfIcon />
                    </IconButton>

                    <IconButton aria-label="emailpdf" color={params.row.emargementSent ? 'success' : 'warning'} onClick={() => this.sendEmargement(params.row.id)}  >
                        <AttachEmailIcon />
                    </IconButton>
                    </div>
                ),
            },

            {
                field: 'attestation',
                headerName: 'Attestation',
                sortable: false,
                filterable: false,
                minwidth: 100,
                flex: 0.2,
                renderCell: (params) => (
                    <div>

                    <IconButton aria-label="pdf" color={params.row.attestationSent ? 'success' : 'warning'} onClick={() => this.editAttestation(params.row.id)} >
                        <PictureAsPdfIcon />
                    </IconButton>

                    <IconButton aria-label="emailpdf" color={params.row.attestationSent ? 'success' : 'warning'} onClick={() => this.sendAttestation(params.row.id)}  >
                        <AttachEmailIcon />
                    </IconButton>
                    </div>
                ),
            },

            {
                field: 'questionaire',
                headerName: 'Questionaire',
                filterable: false,
                sortable: false,
                minwidth: 100,
                flex: 0.2,
                renderCell: (params) => (
                    <div>

                    <IconButton aria-label="pdf" color="primary" disabled>
                        <PictureAsPdfIcon />
                    </IconButton>

                    <IconButton aria-label="emailpdf" color="secondary" disabled  >
                        <AttachEmailIcon />
                    </IconButton>
                    </div>
                ),
            },


            {
                field: 'actions',
                headerName: 'Actions',
                sortable: false,
                filterable: false,
                minwidth: 100,
                flex: 0.2,
                renderCell: (params) => (
                    <div>

                    <IconButton aria-label="edit" color="danger" onClick={() => { this.editDossier(params.row) }} >
                        <ModeEditIcon />
                    </IconButton>

                    <IconButton aria-label="delete" color="danger" onClick={() => this.remove(params.row.id)}>
                        <DeleteIcon />
                    </IconButton>
                    </div>
                ),
            },


           
        ];


        const pageSizes = this.pageSizes;

        let addDossierClose = () => this.setState({ addDossierShow: false, currentDossier: this.emptyDossier });
       // let addFilterClose = () => this.setState({ addFilterShow: false });
        //const reload = () => window.location.reload();

        if (isLoading) {
            return <p>Loading...</p>;
        }
       


        let paginationModel = {
            page: page,
            pageSize: pageSize
        };

        const columnVisibilityModel = {
            id: false,
        };


        return (
            <div>
                <Container fluid>
                    <Snackbar
                        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                        open={this.state.snackbaropen}
                        autoHideDuration={5000}
                        onClose={this.snackbarClose}
                        message={<span id='message-id'> {this.state.snackbarmsg}  </span>}
                        action={[
                            <IconButton
                                key="close"
                                aria-label='Close'
                                color='inherit'
                                onClick={this.snackbarClose}
                            >X</IconButton>
                        ]}
                    ></Snackbar>
                    <br />
                    <Row>
                        <Col xs={10} md={10}><h3>Dossiers</h3></Col>
                        <Col xs={2} md={2}>
                            <Button variant="contained" onClick={() => { this.editDossier(this.state.currentDossier) }}>Ajout Dossier</Button>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={2} md={2}>
                            <Button variant="contained" startIcon={<TuneIcon />} disabled onClick={() => { this.filterDossier() }}>
                                Filtres
                            </Button>
                        </Col>

                    </Row>

                </Container>
                <div style={{ height: 800, width: '100%' }}>
                    <StripedDataGrid
                        rows={dossiers}
                        columns={columns}
                        pageSizeOptions={pageSizes}

                        rowCount={count}
                        loading={isLoading}
                        columnVisibilityModel={columnVisibilityModel}

                        paginationModel={paginationModel}
                        paginationMode="server"
                        onPaginationModelChange={this.handlePageChange}

                        getRowClassName={(params) =>
                            params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'
                        }
                    // pagination
                    //checkboxSelection
                    //disableSelectionOnClick
                    />
                    <AddDossier show={this.state.addDossierShow} onHide={addDossierClose} refreshParentDossier={this.refreshDossier} currentdossier={this.state.currentDossier} ></AddDossier>
                    
              
                   
               
                </div>

                    
            </div>
        );
    }



}
export default DossierList;